import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppLayout } from "~/components/layouts/app";
import { getOnboardingChannels } from "~/functions/onboarding";
import { useUser } from "~/hooks/use-session";
import { seo } from "~/modules/page/seo";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute("/_app/podcasts/$channelUid")({
	component: Layout,
	beforeLoad: async ({ params }) => {
		const onboardingChannels = await getOnboardingChannels();

		return {
			isOnboarding: onboardingChannels.includes(params.channelUid),
		};
	},
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(context.trpc.channel.list.queryOptions());

		const [channel] = await Promise.all([
			context.queryClient.ensureQueryData(
				context.trpc.channel.find.queryOptions({
					channelUid: params.channelUid,
				}),
			),
		]);

		return {
			meta: {
				title: channel.title,
			},
		};
	},
	head: ({ loaderData }) => ({
		meta: [
			...seo({
				title: `${loaderData?.meta.title} | Azerion`,
				description: "Host & Monetize your podcasts.",
			}),
		],
	}),
});

function Layout() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();
	const { user } = useUser();

	const channelQuery = useSuspenseQuery(trpc.channel.find.queryOptions({ channelUid }));
	const channelsQuery = useSuspenseQuery(trpc.channel.list.queryOptions());

	return (
		<AppLayout channel={channelQuery.data} channels={channelsQuery.data} user={user}>
			<Outlet />
		</AppLayout>
	);
}
